import { Button, Modal } from "react-bootstrap";
import { useState } from "react";
import { useMerchant } from "context/merchant";
import { useLogout } from "../hooks/useLogout";

export default function LogoutModal({ show, handleClose }) {
  const { isFullScreen } = useMerchant();
  const logout = useLogout();
  const [loading, setLoading] = useState(false);

  const handleLogout = async () => {
    setLoading(true);
    await logout(); // төгсгөлд window.location.reload() хийгдэнэ
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton className="bg-primary">
        <h4 className="header-title text-white">Системээс гарах</h4>
      </Modal.Header>
      <Modal.Body>
        <div>Та системээс гарахдаа итгэлтэй байна уу?</div>
      </Modal.Body>
      <Modal.Footer>
        <div
          className={`btn btn-outline-primary ${isFullScreen && "btn-lg"}`}
          onClick={handleClose}
        >
          Болих
        </div>
        <Button
          className={`btn btn-primary ${isFullScreen && "btn-lg"}`}
          onClick={handleLogout}
          disabled={loading}
        >
          {loading ? (
            <>
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              <span className="ms-2">Түр хүлээнэ үү...</span>
            </>
          ) : (
            "Гарах"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
